import { useEffect, useState } from 'react';

import { Row, Col, Typography, Skeleton, Table, notification } from 'antd';

import { CustomButton } from '../../../components';
import MESSAGES from '../../../enums/Messages';
import { Link } from 'react-router-dom';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import PdfViewer from '../../../components/PdfViewer';
import { getDocuments } from '../../../api/module/ctm_director';
import { generateTemplateURL } from '../../../api/module/template';

const { Title } = Typography;

const breadcrumbItems = [
  {
    text: 'Firma de modificaciones contractuales de Contratistas y Proveedores',
    to: `${INTERNAL_LINKS.MODIFICATION_DIRECTOR}`,
  },
  {
    text: 'Validación y Firma de Modificación Contractual',
  },
];

const initModalState = {
  pdf: undefined,
  open: false,
  key: 'no-key',
};

export default function ContractModificationDirectorDocumentForm({ match }) {
  const [modalState, setModalState] = useState(initModalState);
  const [contractData, setContractData] = useState(undefined);
  const [loadingPDF, setLoadingPDF] = useState(undefined);

  useEffect(() => {
    async function fetchData(id) {
      try {
        const res = await getDocuments(id);
        setContractData(res.data);
      } catch (err) {
        console.log(err);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_GET_MSG,
          duration: 2,
        });
      }
    }
    fetchData(match.params.validation_id);
  }, [match.params.validation_id]);

  const columns = [
    {
      title: 'Tipo de documento',
      render: (_, record) => {
        return record.plantilla_codigo != null
          ? record.plantilla_codigo + ' - ' + record.plantilla_nombre
          : record.plantilla_nombre;
      },
    },
    {
      title: 'Ver',
      key: 'actions',
      align: 'center',
      render: (_, record) => {
        return (
          <CustomButton
            type="default"
            text="Visualizar"
            htmlType="button"
            loading={loadingPDF === record.tipo_plantilla}
            disabled={loadingPDF}
            onClick={async () => {
              setLoadingPDF(record.tipo_plantilla);
              try {
                const response = await generateTemplateURL({
                  template: record.tipo_plantilla,
                  person: contractData.tercero,
                  term: contractData.termino,
                  contract: contractData.contrato,
                  modification: contractData.modificacion,
                  version: record.plantilla_version,
                });
                setModalState({
                  open: true,
                  pdf: response.data.url,
                  key: `pdf-${record.tipo_plantilla}`,
                });
              } catch (err) {
                console.log(err);
                notification.error({
                  message: MESSAGES.ERROR_MSG,
                  description: MESSAGES.DESC_ERROR_GET_MSG,
                  duration: 2,
                });
              }
              setLoadingPDF(undefined);
            }}
          />
        );
      },
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <div className="box-title">
        <Title>Validación y Firma de Modificación Contractual</Title>
      </div>
      {contractData ? (
        <div className="box-description">
          <Row>
            <Col span={22} offset={1}>
              <Table
                dataSource={contractData.documentos}
                columns={columns}
                bordered
                rowKey="id"
                scroll={{ x: 'max-content' }}
                pagination={false}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <Skeleton active loading={true} />
      )}
      <Row justify="space-around" style={{ marginTop: '15px' }}>
        <CustomButton
          danger="true"
          htmlType="button"
          text={
            <Link to={`${INTERNAL_LINKS.MODIFICATION_DIRECTOR}`}>Volver</Link>
          }
        />
      </Row>

      <PdfViewer
        pdf={modalState.pdf}
        open={modalState.open}
        onCancel={() => setModalState(initModalState)}
        isWord={true}
      />
    </>
  );
}
